/**
 * @fileoverview gRPC-Web generated client stub for trnspb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: trnspb/pendingtrns.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../google/api/annotations_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')

var trnspb_transaction_pb = require('../trnspb/transaction_pb.js')
const proto = {};
proto.trnspb = require('./pendingtrns_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trnspb.PendingTrnsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trnspb.PendingTrnsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trnspb.ListPendingTrnsRequest,
 *   !proto.trnspb.ListPendingTrnsResponse>}
 */
const methodDescriptor_PendingTrnsService_ListPendingTrns = new grpc.web.MethodDescriptor(
  '/trnspb.PendingTrnsService/ListPendingTrns',
  grpc.web.MethodType.UNARY,
  proto.trnspb.ListPendingTrnsRequest,
  proto.trnspb.ListPendingTrnsResponse,
  /**
   * @param {!proto.trnspb.ListPendingTrnsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trnspb.ListPendingTrnsResponse.deserializeBinary
);


/**
 * @param {!proto.trnspb.ListPendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trnspb.ListPendingTrnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trnspb.ListPendingTrnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trnspb.PendingTrnsServiceClient.prototype.listPendingTrns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ListPendingTrns',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ListPendingTrns,
      callback);
};


/**
 * @param {!proto.trnspb.ListPendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trnspb.ListPendingTrnsResponse>}
 *     Promise that resolves to the response
 */
proto.trnspb.PendingTrnsServicePromiseClient.prototype.listPendingTrns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ListPendingTrns',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ListPendingTrns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trnspb.ListPendingTrnsWithLegsRequest,
 *   !proto.trnspb.ListPendingTrnsWithLegsResponse>}
 */
const methodDescriptor_PendingTrnsService_ListPendingTrnsWithLegs = new grpc.web.MethodDescriptor(
  '/trnspb.PendingTrnsService/ListPendingTrnsWithLegs',
  grpc.web.MethodType.UNARY,
  proto.trnspb.ListPendingTrnsWithLegsRequest,
  proto.trnspb.ListPendingTrnsWithLegsResponse,
  /**
   * @param {!proto.trnspb.ListPendingTrnsWithLegsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trnspb.ListPendingTrnsWithLegsResponse.deserializeBinary
);


/**
 * @param {!proto.trnspb.ListPendingTrnsWithLegsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trnspb.ListPendingTrnsWithLegsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trnspb.ListPendingTrnsWithLegsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trnspb.PendingTrnsServiceClient.prototype.listPendingTrnsWithLegs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ListPendingTrnsWithLegs',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ListPendingTrnsWithLegs,
      callback);
};


/**
 * @param {!proto.trnspb.ListPendingTrnsWithLegsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trnspb.ListPendingTrnsWithLegsResponse>}
 *     Promise that resolves to the response
 */
proto.trnspb.PendingTrnsServicePromiseClient.prototype.listPendingTrnsWithLegs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ListPendingTrnsWithLegs',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ListPendingTrnsWithLegs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trnspb.ReadPendingTrnsRequest,
 *   !proto.trnspb.ReadPendingTrnsResponse>}
 */
const methodDescriptor_PendingTrnsService_ReadTransaction = new grpc.web.MethodDescriptor(
  '/trnspb.PendingTrnsService/ReadTransaction',
  grpc.web.MethodType.UNARY,
  proto.trnspb.ReadPendingTrnsRequest,
  proto.trnspb.ReadPendingTrnsResponse,
  /**
   * @param {!proto.trnspb.ReadPendingTrnsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trnspb.ReadPendingTrnsResponse.deserializeBinary
);


/**
 * @param {!proto.trnspb.ReadPendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trnspb.ReadPendingTrnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trnspb.ReadPendingTrnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trnspb.PendingTrnsServiceClient.prototype.readTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ReadTransaction',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ReadTransaction,
      callback);
};


/**
 * @param {!proto.trnspb.ReadPendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trnspb.ReadPendingTrnsResponse>}
 *     Promise that resolves to the response
 */
proto.trnspb.PendingTrnsServicePromiseClient.prototype.readTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ReadTransaction',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ReadTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trnspb.DeletePendingTrnsRequest,
 *   !proto.trnspb.DeletePendingTrnsResponse>}
 */
const methodDescriptor_PendingTrnsService_DeletePendingTrns = new grpc.web.MethodDescriptor(
  '/trnspb.PendingTrnsService/DeletePendingTrns',
  grpc.web.MethodType.UNARY,
  proto.trnspb.DeletePendingTrnsRequest,
  proto.trnspb.DeletePendingTrnsResponse,
  /**
   * @param {!proto.trnspb.DeletePendingTrnsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trnspb.DeletePendingTrnsResponse.deserializeBinary
);


/**
 * @param {!proto.trnspb.DeletePendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trnspb.DeletePendingTrnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trnspb.DeletePendingTrnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trnspb.PendingTrnsServiceClient.prototype.deletePendingTrns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trnspb.PendingTrnsService/DeletePendingTrns',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_DeletePendingTrns,
      callback);
};


/**
 * @param {!proto.trnspb.DeletePendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trnspb.DeletePendingTrnsResponse>}
 *     Promise that resolves to the response
 */
proto.trnspb.PendingTrnsServicePromiseClient.prototype.deletePendingTrns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trnspb.PendingTrnsService/DeletePendingTrns',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_DeletePendingTrns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trnspb.UpdatePendingTrnsApplyCILRequest,
 *   !proto.trnspb.UpdatePendingTrnsApplyCILRResponse>}
 */
const methodDescriptor_PendingTrnsService_UpdatePendingTrnsApplyCIL = new grpc.web.MethodDescriptor(
  '/trnspb.PendingTrnsService/UpdatePendingTrnsApplyCIL',
  grpc.web.MethodType.UNARY,
  proto.trnspb.UpdatePendingTrnsApplyCILRequest,
  proto.trnspb.UpdatePendingTrnsApplyCILRResponse,
  /**
   * @param {!proto.trnspb.UpdatePendingTrnsApplyCILRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trnspb.UpdatePendingTrnsApplyCILRResponse.deserializeBinary
);


/**
 * @param {!proto.trnspb.UpdatePendingTrnsApplyCILRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trnspb.UpdatePendingTrnsApplyCILRResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trnspb.UpdatePendingTrnsApplyCILRResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trnspb.PendingTrnsServiceClient.prototype.updatePendingTrnsApplyCIL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trnspb.PendingTrnsService/UpdatePendingTrnsApplyCIL',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_UpdatePendingTrnsApplyCIL,
      callback);
};


/**
 * @param {!proto.trnspb.UpdatePendingTrnsApplyCILRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trnspb.UpdatePendingTrnsApplyCILRResponse>}
 *     Promise that resolves to the response
 */
proto.trnspb.PendingTrnsServicePromiseClient.prototype.updatePendingTrnsApplyCIL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trnspb.PendingTrnsService/UpdatePendingTrnsApplyCIL',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_UpdatePendingTrnsApplyCIL);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trnspb.ExecutePendingTrnsRequest,
 *   !proto.trnspb.ExecutePendingTrnsResponse>}
 */
const methodDescriptor_PendingTrnsService_ExecutePendingTrns = new grpc.web.MethodDescriptor(
  '/trnspb.PendingTrnsService/ExecutePendingTrns',
  grpc.web.MethodType.UNARY,
  proto.trnspb.ExecutePendingTrnsRequest,
  proto.trnspb.ExecutePendingTrnsResponse,
  /**
   * @param {!proto.trnspb.ExecutePendingTrnsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trnspb.ExecutePendingTrnsResponse.deserializeBinary
);


/**
 * @param {!proto.trnspb.ExecutePendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trnspb.ExecutePendingTrnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trnspb.ExecutePendingTrnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trnspb.PendingTrnsServiceClient.prototype.executePendingTrns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ExecutePendingTrns',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ExecutePendingTrns,
      callback);
};


/**
 * @param {!proto.trnspb.ExecutePendingTrnsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trnspb.ExecutePendingTrnsResponse>}
 *     Promise that resolves to the response
 */
proto.trnspb.PendingTrnsServicePromiseClient.prototype.executePendingTrns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trnspb.PendingTrnsService/ExecutePendingTrns',
      request,
      metadata || {},
      methodDescriptor_PendingTrnsService_ExecutePendingTrns);
};


module.exports = proto.trnspb;

